import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import PoliciesNew from "../components/contracts/policies/policiesForm";

const PoliciesForm = () => (
 <Container fluid className="main-content-container px-4 pb-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Política de flota" subtitle="Contratos" className="text-sm-left" />
    </Row>
	<Row>
      <Col md="12">
		    <PoliciesNew /> 
      </Col>
    </Row>
  </Container>
);

export default PoliciesForm;
